import Promise from '../../libs/es6-promise/es6-promise'
import find from 'array.prototype.find'
import findIndex from 'array.prototype.findindex'
import values from 'object.values'

import dispatcher from './dispatcher'

import headerDrawer from './headerDrawer'
import pageHeader from'./pageHeader'
import homeHero from'./homeHero'
import homeHeaderPosition from'./homeHeaderPosition'
import homeNews from'./homeNews'
import homeEmergency from'./homeEmergency'
import instSearch from'./instSearch'
import holidays from'./holidays'
import cancerexam from'./cancerexam'
import vaccination from'./vaccination'
import news from'./news'
import emergency from'./emergency'

if (!window.Promise) {
	window.Promise = Promise
}

if (!Array.prototype.find) {
	find.shim()
}

if (!Array.prototype.findIndex) {
	findIndex.shim()
}

if (!Object.values) {
	values.shim()
}


if (!window.initMap) {
	window.initMap = () => {}
}


// 全ページ共通
dispatcher.add('.*', () => {
	window.headerDrawer = headerDrawer()
})

// ホーム以外
dispatcher.add('^/.+', pageHeader)

// ホーム
dispatcher.add('^/(?:index\.html)?$', () => {
	homeHero()
	homeHeaderPosition()
	homeNews(18)
	homeEmergency(18)
})

// 病院検索
dispatcher.add('^/institutions\/(index\.html)?$', instSearch)

// 病院詳細
dispatcher.add('^/institutions\/detail', () => {
	// 地図
	const initMap = () => {
		const el = document.querySelector('.inst-detail-map')
		if (!el) {
			return
		}
		const lat = el.getAttribute('data-lat') - 0
		const lng = el.getAttribute('data-lng') - 0
		const map = new google.maps.Map(el, {
			center: {lat, lng},
			zoom: 16,
			scrollwheel: false,
			mapTypeControl: false,
			streetViewControl: false
		})
		const marker = new google.maps.Marker({
			position: {lat, lng},
			map
		})
		const infoWindow = new google.maps.InfoWindow({
			content: '<div class="infoWindow">' + el.getAttribute('data-title') + '</div>'
		})

        infoWindow.open(map, marker)
	}
	window.initMap = initMap

	// 詳細から戻る
	const backFromDetail = () => {
		const referrer = document.referrer || ''
		const current = location.protocol + '//' + location.hostname
		console.log(referrer)
		if (referrer.indexOf(current) === 0) {
			history.back()
			return false
		}
	}
	window.backFromDetail = backFromDetail
})

// 病院検索
dispatcher.add('^/holidays\/(index\.html)?$', holidays)

dispatcher.add('^/cancerexam\/(index\.html)?$', cancerexam)

dispatcher.add('^/vaccination\/(index\.html)?$', vaccination)
dispatcher.add('^/vaccination\/table\.html$', vaccination)


// 医師会お知らせ
dispatcher.add('^/info\/(index\.html)?$', () => {
	news(18)
	emergency(18)
})


// 検診センター ホーム
dispatcher.add('^/kenshin\/(index\.html)?$', () => {
	homeHero()
	homeHeaderPosition()
	homeNews(29)
})

dispatcher.add('^/kenshin\/guide\/', () => {
	Array.prototype.forEach.call(document.querySelectorAll('.k-accordion'), el => {
		el.querySelector('.k-accordion__heading').addEventListener('click', () => {
			const current = el.getAttribute('aria-expanded')
			const next = current !== 'true'
			el.setAttribute('aria-expanded', next)
		})
	})
})

// 検診センターお知らせ
dispatcher.add('^/kenshin/topics\/(index\.html)?$', () => {
	news(29)
})

// 実行
dispatcher.dispatch()